var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carPark"},[_c('router-view',{staticClass:"aaaa"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }